import * as React from 'react'
import { customerMarketShopfrontApi } from '@envato/foundation-types'
import Button, { ButtonAppearance, ButtonSize } from '@envato/foundation-button'
import get from 'lodash-es/get'

import { reportCategoryPageClick } from '../../../../common/analytics/categoryPageAnalytics'
import { IBlockMatchedComponent } from '../../../pages/category/category'
import { IItem } from '../../../../typings/searchResults'
import ItemCard from '../../itemCard'
import ItemCardsLayout from '../../itemCardsLayout'
import FeatureContainer from '../../../containers/feature'

import * as styles from './promoItemsBlock.module.css'

interface IProps extends IBlockMatchedComponent {
  data: IItem[]
  title: string
  cta?: customerMarketShopfrontApi.categoryPage.ICta
}

const blockTitle = {
  audiojungle: {
    message1: 'Explore royalty-free audio tracks & sounds.',
    message2: 'Save on royalty-free audio tracks & sounds.',
    message3: 'Save up to 40% on royalty-free audio tracks & sounds.'
  },
  videohive: {
    message1: 'Explore royalty-free video templates & stock footage.',
    message2: 'Save on royalty-free video templates & stock footage.',
    message3: 'Save up to 40% on royalty-free video templates & stock footage.'
  }
}

const PromoItemsBlock = ({ subtitle, cta, data, currentSite }: IProps) => {
  return (
    <section className={styles.root}>
      <div className={styles.promoItemsBlockWrapper}>
        <ItemCardsLayout viewType="grid">
          <ItemCardsLayout.CardArea className={styles.promoItem}>
            <div className={styles.campaignTextWrapper}>
              <header>
                <h2 className={styles.title}>
                  <FeatureContainer name="showSaleMessage1">
                    {get(blockTitle, `${currentSite}.message1`)}
                  </FeatureContainer>
                  <FeatureContainer name="showSaleMessage2">
                    {get(blockTitle, `${currentSite}.message2`)}
                  </FeatureContainer>
                  <FeatureContainer name="showSaleMessage3">
                    {get(blockTitle, `${currentSite}.message3`)}
                  </FeatureContainer>
                </h2>
                {subtitle && <h3 className={styles.subtitle}>{subtitle}</h3>}
              </header>

              {cta && (
                <Button
                  className={styles.button}
                  appearance={ButtonAppearance.Primary}
                  onClick={reportCategoryPageClick('Cyber Monday sale 3up')}
                  size={ButtonSize.Small}
                  href={cta.url}
                >
                  {cta.title}
                </Button>
              )}
            </div>
          </ItemCardsLayout.CardArea>
          {data.map((item, index) => (
            <ItemCardsLayout.CardArea key={item.id}>
              <ItemCard
                listName="Category page"
                item={item}
                index={index}
                viewType="grid"
              />
            </ItemCardsLayout.CardArea>
          ))}
        </ItemCardsLayout>
      </div>
    </section>
  )
}

export default PromoItemsBlock
